<script>
export default {
	name: 'PrivacyPolicy',
};
</script>

<template>
	<div class="container">
		<div class="privacy-policy">
			<h1 class="title fs-56 mb-40">Политика обработки персональных данных</h1>
			
			<div class="policy-content">
				<p class="fs-18 mb-20">
					Настоящая Политика обработки персональных данных (далее — Политика) действует в отношении всей информации, 
					которую ИП Гаврилов Михаил Игоревич (далее — Оператор) может получить о пользователе во время использования 
					сайта и сервисов VPN.
				</p>

				<h2 class="fs-32 mb-20">1. Основные понятия</h2>
				<ul class="fs-18 mb-30">
					<li><strong>Персональные данные</strong> — любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных);</li>
					<li><strong>Обработка персональных данных</strong> — любое действие (операция) или совокупность действий (операций), совершаемых с персональными данными с использованием средств автоматизации или без использования таких средств;</li>
					<li><strong>Конфиденциальность персональных данных</strong> — обязательное для соблюдения Оператором или иным получившим доступ к персональным данным лицом требование не допускать их распространения без согласия субъекта персональных данных или наличия иного законного основания.</li>
				</ul>

				<h2 class="fs-32 mb-20">2. Цели обработки персональных данных</h2>
				<p class="fs-18 mb-20">
					Оператор обрабатывает персональные данные в следующих целях:
				</p>
				<ul class="fs-18 mb-30">
					<li>Предоставление услуг VPN;</li>
					<li>Обработка платежей;</li>
					<li>Техническая поддержка пользователей;</li>
					<li>Информирование о новых услугах и акциях;</li>
					<li>Соблюдение требований законодательства РФ.</li>
				</ul>

				<h2 class="fs-32 mb-20">3. Категории обрабатываемых персональных данных</h2>
				<p class="fs-18 mb-20">
					Оператор обрабатывает следующие категории персональных данных:
				</p>
				<ul class="fs-18 mb-30">
					<li>Фамилия, имя, отчество;</li>
					<li>Адрес электронной почты;</li>
					<li>Номер телефона;</li>
					<li>Платежные реквизиты;</li>
					<li>Техническая информация (IP-адрес, данные браузера, время посещения);</li>
					<li>UID из приложения;</li>
					<li>Информация об использовании сервиса.</li>
				</ul>

				<h2 class="fs-32 mb-20">4. Правовые основания обработки</h2>
				<p class="fs-18 mb-20">
					Обработка персональных данных осуществляется на основании:
				</p>
				<ul class="fs-18 mb-30">
					<li>Согласия субъекта персональных данных;</li>
					<li>Исполнения договора, стороной которого является субъект персональных данных;</li>
					<li>Соблюдения требований законодательства РФ.</li>
				</ul>

				<h2 class="fs-32 mb-20">5. Порядок обработки персональных данных</h2>
				<p class="fs-18 mb-20">
					Оператор осуществляет обработку персональных данных в соответствии с принципами:
				</p>
				<ul class="fs-18 mb-30">
					<li>Законности и справедливой основы;</li>
					<li>Ограничения конкретными, заранее определенными и законными целями;</li>
					<li>Соответствия содержания и объема обрабатываемых персональных данных заявленным целям;</li>
					<li>Точности, достаточности и актуальности персональных данных;</li>
					<li>Хранения персональных данных в форме, позволяющей определить субъекта персональных данных не дольше, чем этого требуют цели обработки.</li>
				</ul>

				<h2 class="fs-32 mb-20">6. Меры защиты персональных данных</h2>
				<p class="fs-18 mb-20">
					Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения персональных данных, а также от иных неправомерных действий в отношении персональных данных.
				</p>

				<h2 class="fs-32 mb-20">7. Передача персональных данных третьим лицам</h2>
				<p class="fs-18 mb-20">
					Оператор не передает персональные данные третьим лицам, за исключением случаев:
				</p>
				<ul class="fs-18 mb-30">
					<li>Получения согласия субъекта персональных данных;</li>
					<li>Требований законодательства РФ;</li>
					<li>Обработки платежей через платежные системы;</li>
					<li>Технической поддержки (с соблюдением конфиденциальности).</li>
				</ul>

				<h2 class="fs-32 mb-20">8. Сроки хранения персональных данных</h2>
				<p class="fs-18 mb-20">
					Персональные данные хранятся в течение срока, необходимого для достижения целей обработки, но не более 5 лет с момента последнего взаимодействия с пользователем, если иное не предусмотрено законодательством РФ.
				</p>

				<h2 class="fs-32 mb-20">9. Права субъекта персональных данных</h2>
				<p class="fs-18 mb-20">
					Субъект персональных данных имеет право:
				</p>
				<ul class="fs-18 mb-30">
					<li>Получать информацию об обработке его персональных данных;</li>
					<li>Требовать уточнения персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки;</li>
					<li>Отзывать согласие на обработку персональных данных;</li>
					<li>Обжаловать действия или бездействие Оператора в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке.</li>
				</ul>

				<h2 class="fs-32 mb-20">10. Контактная информация</h2>
				<p class="fs-18 mb-20">
					По вопросам обработки персональных данных обращайтесь:
				</p>
				<div class="fs-18 mb-30">
					<p><strong>ИП Гаврилов Михаил Игоревич</strong></p>
					<p>ОГРНИП: 323784700149322</p>
					<p>ИНН: 781156332638</p>
					<p>Банковские реквизиты:</p>
					<p>БИК: 044525974</p>
					<p>Название банка: АО "ТБанк"</p>
					<p>Корр. счет: 30101810145250000974</p>
					<p>Расчетный счет: 40802810600004664829</p>
					<p>Email: <a href="mailto:privacy@myvpn.com" class="text-violet">privacy@myvpn.com</a></p>
					<p>Telegram: <a href="https://t.me/myvpn_chat" target="_blank" class="text-violet">@myvpn_chat</a></p>
				</div>

				<h2 class="fs-32 mb-20">11. Изменения в Политике</h2>
				<p class="fs-18 mb-20">
					Оператор вправе вносить изменения в настоящую Политику. При внесении изменений в актуальной редакции указывается дата последнего обновления. Новая редакция Политики вступает в силу с момента ее размещения на сайте, если иное не предусмотрено новой редакцией Политики.
				</p>

				<div class="fs-16 text-muted mt-40">
					<p>Дата последнего обновления: {{ new Date().toLocaleDateString('ru-RU') }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.privacy-policy {
	max-width: 800px;
	margin: 0 auto;
	padding: 20px;
}

.policy-content {
	line-height: 1.6;
}

.policy-content ul {
	padding-left: 20px;
}

.policy-content li {
	margin-bottom: 10px;
}

.text-muted {
	color: #A6ADB8;
}

a.text-violet {
	color: #8B5CF6;
	text-decoration: underline;
}

a.text-violet:hover {
	color: #7C3AED;
}
</style>
